import { Button, CardActions, CardContent, CircularProgress, Typography } from '@mui/material'
import { useTranslate } from 'ra-core'
import * as React from 'react'
import { Link } from 'react-router-dom'

import { useCommonStyles } from '../../config/theme'

const AuthFormSection = ({ children, submitText, isLoading, disabled, linkTo, linkText }) => {
  const translate = useTranslate()
  const commonClasses = useCommonStyles()

  const disabledChildren = React.Children.map(children, (child) =>
    React.isValidElement(child) ? React.cloneElement(child, { disabled }) : child,
  )

  return (
    <>
      <CardContent sx={{ padding: '0 1em 1em 1em' }}>{disabledChildren}</CardContent>
      <CardActions>
        <Button variant="contained" color="primary" type="submit" disabled={disabled} sx={{ width: '100%' }}>
          {isLoading && <CircularProgress sx={{ marginRight: 1 }} size={18} thickness={2} />}
          {translate(submitText)}
        </Button>
      </CardActions>
      {linkTo && linkText && (
        <CardActions sx={{ justifyContent: 'center' }}>
          <Typography component="span" variant="body2" color="primary">
            <Link to={linkTo} sx={commonClasses.link}>
              {translate(linkText)}
            </Link>
          </Typography>
        </CardActions>
      )}
    </>
  )
}

export default AuthFormSection
